import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, MapPin } from 'lucide-react';
import { useLang } from '../i18n';
import { useSEO } from '../seo';
import { PageHeader } from '../components/PageHeader';
import { Reveal } from '../components/Reveal';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function TravelGuidesPage() {
  const { t } = useLang();
  useSEO('Guias de Viagem | Eco Collection', 'Guias e histórias locais de São Tomé e Príncipe e Cabo Verde.');
  const [guides, setGuides] = useState([]);

  useEffect(() => {
    fetch(`${API}/guides`)
      .then((r) => r.json())
      .then((d) => setGuides(Array.isArray(d) ? d : []))
      .catch(() => setGuides([]));
  }, []);

  return (
    <div data-testid="travel-guides-page">
      <PageHeader kicker={t('page.guides.k')} title={t('page.guides.t')} sub={t('page.guides.s')} />
      <section className="bg-eco-cream py-14 md:py-20">
        <div className="mx-auto grid max-w-6xl gap-6 px-5 sm:grid-cols-2 lg:grid-cols-3 md:px-8">
          {guides.map((g, i) => (
            <Reveal key={g.slug} delay={(i % 3) * 0.08}>
              <Link
                to={`/travel-guides/${g.slug}`}
                data-testid={`guide-card-${g.slug}`}
                className="group eco-card flex h-full flex-col"
              >
                {g.image && (
                  <div className="relative h-52 shrink-0 overflow-hidden">
                    <img src={g.image} alt={g.title} loading="lazy" className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110" />
                  </div>
                )}
                <div className="flex flex-1 flex-col p-6">
                  <p className="flex items-center gap-1.5 text-[12px] font-semibold tracking-[0.14em] uppercase text-eco-gold">
                    <MapPin size={11} /> {g.destination}
                  </p>
                  <h2 className="eco-card-title mt-2">{g.title}</h2>
                  <p className="eco-secondary mt-2 flex-1 text-eco-ink/60">{g.excerpt}</p>
                  <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-eco-gold transition-colors group-hover:text-eco-green">
                    {t('read.more')} <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
          {guides.length === 0 && (
            <p data-testid="guides-empty" className="col-span-full rounded-3xl border border-dashed border-eco-ink/15 bg-white py-14 text-center text-sm text-eco-ink/50">
              {t('partners.empty')}
            </p>
          )}
        </div>
      </section>
    </div>
  );
}
